const clientConfig = {
  apiKey: 'AIzaSyAlgE8Ys5Al-in7NnfxUp3lJXxQORYFiyg',
  clientId: '14713815642-e0t9egfauvn5iskok290en62ldopik80.apps.googleusercontent.com',
  discoveryDocs: ['https://docs.googleapis.com/$discovery/rest?version=v1'],
  // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
  scope: 'https://www.googleapis.com/auth/documents',
  // works only with `ux_mode: "prompt"`
  refreshToken: true,
}

export default { clientConfig }
